export const AUDIT = 'audit';
export const TYPE = 'type';
export const STATUS = 'status';

// only FilterMisalignmentOverlay
export const DEEP_LINKED_THREAD_MISSING = ['deepLinkedThreadMissing'];